import { Skeleton } from '@radix-ui/themes';
import type { MatchDrawType } from 'types/match';
import MatchCardObject from './MatchCardObject';

export const DrawTurnContainer: React.FC<{
  loading: boolean;
  competitionName: string;
  matches: MatchDrawType[];
  onDeleteMatch: (match: { is_deletable: boolean; id: number }) => void;
  editMatchResult: (match: { is_editable: boolean; id: number; type: string }) => void;
}> = ({ loading, competitionName, onDeleteMatch, editMatchResult, matches }) => {
  return (
    <div
      id='container'
      className='border-neutral-neutral-2 flex flex-col items-start gap-2 self-stretch rounded-2xl border border-solid bg-white p-3'
    >
      <div className='w-full'>
        <div
          id='competition'
          className='flex w-full flex-row flex-wrap content-center items-center justify-between gap-3 rounded-xl p-1'
        >
          <Skeleton loading={loading} className='h-auto w-auto'>
            <div
              id='competitionName'
              className='text-neutral-neutral-12 grow basis-44 text-xl font-medium tracking-tighter md:basis-96'
            >
              {competitionName}
            </div>
          </Skeleton>
        </div>
      </div>

      <Skeleton loading={loading} className='h-auto w-auto'>
        <div className='w-full'>
          <div
            id='draw_name'
            className='text-neutral-neutral-12 mt-3 flex items-center gap-2 py-3 text-lg font-medium md:shrink-0'
          />
          <div className='grid grid-cols-1 gap-4 lg:grid-cols-2'>
            {matches.map((match) => {
              return (
                <div key={match.id}>
                  <MatchCardObject
                    key={`match-${match.id}`}
                    {...match}
                    first_opponent={match.first_loser}
                    second_opponent={match.second_loser}
                    partner={match.second_winner}
                    draw=''
                    loading={loading}
                    player={match.first_winner}
                    onDeleteMatch={onDeleteMatch}
                    editMatchResult={editMatchResult}
                  />
                </div>
              );
            })}
          </div>
        </div>
      </Skeleton>
    </div>
  );
};

export default DrawTurnContainer;
